import React from 'react'
import ReactDOM, {unmountComponentAtNode} from 'react-dom'
import {DataObjectId} from 'yougile-model'
import {LinkButton} from '@components/common/base/buttons'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {UIElement} from '../ui-element'

export interface LinkButtonProps {
  text?: string

  size?: 'small' | 'medium' | 'big'
  icon?: TablerIcons
  className?: string
  onMouseDown?: (e: React.MouseEvent) => void
}

export class LinkButtonWrapper extends UIElement {
  private props: LinkButtonProps
  private previous: HTMLElement

  constructor(companyId: DataObjectId, props: LinkButtonProps) {
    super(companyId, undefined, undefined)
    this.props = props
  }

  public override render(el: HTMLElement): void {
    el.innerHTML = ''
    el.className = 'ui-link-button-new'

    this.clean()

    renderElement(el, this.props)
    super.render(el)

    this.previous = el
  }

  public clean() {
    // to avoid memory leaks
    this.previous && unmountComponentAtNode(this.previous)
  }
}

const LinkButtonBase = (props: LinkButtonProps) => {
  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault()
    props.onMouseDown?.(e)
  }

  return (
    <LinkButton
      icon={props.icon}
      onMouseDown={onMouseDown}
      className={props.className}
      noPaddings
      size={props.size ?? 'small'}
      iconPadding={'4'}
    >
      {props.text || ''}
    </LinkButton>
  )
}

export const renderElement = (element: HTMLElement, props: LinkButtonProps) => {
  ReactDOM.render(<LinkButtonBase {...props} />, element)
}
